export * from './delete-konstante-request.interface';
export * from './delete-konstante-response.interface';
export * from './delete-konstante.shapes';
